var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeSuppliesPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0045 20.0332V25.4992H21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 27H15C15.3943 26.9998 15.7849 27.0774 16.1492 27.2282C16.5136 27.3791 16.8446 27.6003 17.1234 27.8792C17.4021 28.1581 17.6232 28.4893 17.7739 28.8537C17.9245 29.2181 18.0019 29.6087 18.0015 30.003H36.009C36.4068 30.003 36.7884 30.161 37.0697 30.4423C37.351 30.7236 37.509 31.1052 37.509 31.503V34.503C37.5092 34.7001 37.4705 34.8953 37.3952 35.0775C37.32 35.2596 37.2095 35.4252 37.0702 35.5646C36.9309 35.7041 36.7655 35.8147 36.5834 35.8902C36.4013 35.9657 36.2061 36.0045 36.009 36.0045H13.5C12.7044 36.0045 11.9413 35.6884 11.3787 35.1258C10.8161 34.5632 10.5 33.8002 10.5 33.0045V30.003C10.4998 29.6089 10.5773 29.2186 10.7279 28.8545C10.8786 28.4903 11.0996 28.1594 11.3781 27.8807C11.6567 27.602 11.9875 27.3809 12.3516 27.23C12.7157 27.0791 13.1059 27.0015 13.5 27.0015V27Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4897 20.6426L31.2597 13.5896C31.4217 13.5296 31.5912 13.4981 31.7637 13.4951H36.0057C36.4035 13.4951 36.785 13.6532 37.0663 13.9345C37.3477 14.2158 37.5057 14.5973 37.5057 14.9951V18.4466C37.5062 18.7562 37.4108 19.0583 37.2328 19.3116C37.0547 19.5648 36.8027 19.7568 36.5112 19.8611L16.4967 26.9996H13.4967C13.1023 27.0002 12.7118 26.923 12.3473 26.7725C11.9828 26.6221 11.6515 26.4012 11.3725 26.1225C11.0934 25.8439 10.872 25.513 10.721 25.1487C10.5699 24.7844 10.4922 24.394 10.4922 23.9996V22.0556C10.4923 21.7459 10.5882 21.4439 10.7668 21.1909C10.9454 20.9379 11.1979 20.7464 11.4897 20.6426Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSuppliesPoi);
export default __webpack_public_path__ + "static/media/office-supplies-poi.8520cf06259c460727bca10bb8da38f3.svg";
export { ForwardRef as ReactComponent };